const px = 1652 / 1012
const py = 2336 / 1414

export const S3_CW2208_TestA_211123 = {
  FRONT: {
    EXAM_GROUP_KEY: '02322008111',
    QR_INFO: {
      checkDigit: 3815,
      correctSize: { w: 1012 * px, h: 1414 * py },
      correctMarkers: {
        tl: { x: 28.5 * px, y: 28.5 * py },
        tr: { x: 982 * px, y: 28.5 * py },
        bl: { x: 28.5 * px, y: 1390 * py },
        br: { x: 982 * px, y: 1390 * py }
      },
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: {
        x: 880 * px,
        y: 200 * py
      },
      numCheckPosition: {
        l: 18 * px,
        t: 77 * py,
        w: 50 * px,
        h: 25 * py
      },
      clipScale: 0.8,
      isHorizontal: false,
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '02322008122',
    QR_INFO: {
      checkDigit: 3824,
      correctSize: { w: 1012 * px, h: 1414 * py },
      correctMarkers: {
        tl: { x: 28.5 * px, y: 28.5 * py },
        tr: { x: 982 * px, y: 28.5 * py },
        bl: { x: 28.5 * px, y: 1390 * py },
        br: { x: 982 * px, y: 1390 * py }
      },
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: {
        x: 830 * px,
        y: 50 * py
      },
      numCheckPosition: {
        l: 945 * px,
        t: 153 * py,
        w: 50 * px,
        h: 25 * py
      },
      clipScale: 0.8,
      isHorizontal: false,
    }
  }
} as const
